<template>
  <div class="v-atlas-raster-geodata-main">
    <template v-if="availableTimestamps.length > 0">
      <p class="timestamp-label">
        Jahr: <strong>{{ requestSettings.timestamp }}</strong>
      </p>

      <template v-if="availableTimestamps.length > 1">
        <input type="range" :min="0" :max="availableTimestamps.length - 1" :value="selectedIndex"
          class="timestamp-slider" @input="onSliderInput">
        <div class="slider-end-labels">
          <span>{{ availableTimestamps[0] }}</span>
          <span>{{ availableTimestamps[availableTimestamps.length - 1] }}</span>
        </div>
      </template>

      <h3>Darstellung</h3>
      <List v-model:selected="requestSettings.colorScheme" class="v-list-chips" :items="colorSchemeOptions"
        :select-mode="SelectMode.Single" :allow-unselect="false">
        <template #item="{ item }">
          {{ item === 'red-yellow-blue' ? 'Rot-Gelb-Blau' : 'Graustufen' }}
        </template>
      </List>
    </template>

    <template v-else>
      <p>Zeitreihe wird geladen…</p>
    </template>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { List, SelectMode, ViewStackController } from "gertrud";
import { RasterGeodataMapModule } from "./RasterGeodataMapModule";

const colorSchemeOptions: Array<"red-yellow-blue" | "greyscale"> = ["red-yellow-blue", "greyscale"];

const props = withDefaults(defineProps<{
  mapModule: RasterGeodataMapModule
  viewStackController: ViewStackController
}>(), {
});

const availableTimestamps = computed(() => props.mapModule.reactiveData.availableTimestamps);
const requestSettings = computed(() => props.mapModule.reactiveData.requestSettings);

const selectedIndex = computed(() => {
  const idx = availableTimestamps.value.indexOf(requestSettings.value.timestamp);
  return idx >= 0 ? idx : 0;
});

function onSliderInput(event: Event): void {
  const idx = parseInt((event.target as HTMLInputElement).value, 10);
  props.mapModule.reactiveData.requestSettings.timestamp = availableTimestamps.value[idx];
}
</script>

<style scoped>
.v-raster-geodata-main {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.timestamp-label {
  margin: 0;
}

.timestamp-slider {
  width: 100%;
}

.slider-end-labels {
  display: flex;
  justify-content: space-between;
  font-size: 0.8em;
  color: var(--color-text-muted, #666);
}
</style>
